import { ClientSnapshotData, PersonalInfo, PolicyIndividualDTO } from '@core/pages/new-business-register/api'

export default class PolicyIndividualImport implements PolicyIndividualDTO {
  utm: number;
  ctm: number;
  oid: string;
  clientDataSnapshot: ClientSnapshotData;
  role: string[];
  clientOid: string;
  nbrOid: string;
  isMainOwner: boolean;
  isLiveData: boolean;
  relationship: string;
}

export class ClientSnapshotDataImport implements ClientSnapshotData {
  lastUpdated: number;
  nextScreeningExtractedDate: number;
  hrcRoles: string[];
  lastSyncSince: number;
  pky: number;
  oid: string;
  ctm: number;
  clientId: string;
  utm: number;
  title: string;
  name: string;
  nric: string;
  mobileNumber: string;
  status: string;
  clientSince: number;
  accountType: string;
  ftfDateOfVerification: number;
  ftfPerformedBy: string;
  ftfJobRole: string;
  ftfRemarks: string;
  casualName: string;
  printingName: string;
  remarks: string;
  isAccreditedInvestor: boolean;
  isOverseasInvestor: boolean;
  isAmlChecked: boolean;
  isDeleted: boolean;
  passedCka: boolean;
  personalInfoJson: PersonalInfo;
}

export class PersonalInfoImport implements PersonalInfo {
  natureOfBusiness: any
  dateOfRegistration: number;
  amlRiskRating: any;
  countryOfBirth: any;
  faxOne: any;
  faxTwo: any;
  previousOccupation: any;
  identityType: any;
  residentialAddressThree: any;
  postalCodeThree: any;
  countryOfResidenceThree: any;
  marketingConsent: any;
  marketingConsentWithdrawalDate: number;
  smokerStatus: any;
  medicalConditionOption: any;
  medicalCondition: any;
  involvedInActivities: any;
  activitiesSpecified: any;
  employmentStatus: any;
  title: any;
  citizenship: any;
  nationalityOthers: any;
  nationalityOthers2: any;
  gender: any;
  dob: any;
  occupation: any;
  maritalStatus: any;
  registrationDate: any;
  residentialAddressOne: any;
  companyAddressOne: any;
  postalCodeOne: any;
  countryOfResidenceOne: any;
  residentialAddressTwo: any;
  companyAddressTwo: any;
  postalCodeTwo: any;
  countryOfResidenceTwo: any;
  mailingAddress: any;
  mailingPostalCode: any;
  mailingCountry: any;
  companyAddressOnePostalCode: any;
  companyAddressOneCountry: any;
  companyAddressTwoPostalCode: any;
  companyAddressTwoCountry: any;
  mobileNoOne: any;
  officeNoOne: any;
  homeNoOne: any;
  emailOne: any;
  mobileNoTwo: any;
  officeNoTwo: any;
  homeNoTwo: any;
  emailTwo: any;
  exactDuties: any;
  companyName: any;
  annualIncomeRange: any;
  highestEducationLevel: any;
  spokenLanguage: string[];
  spokenLanguageOthers: any;
  writtenLanguage: string[];
  writtenLanguageOthers: any;
  isAccreditedInvestor: boolean;
  isOverseasInvestor: boolean;
  ckaPassed: boolean;
  selectedClient: boolean;
  hasBo: boolean;
  hasPep: boolean;
  pdpaMarketing: string[];
  pepNameList: string[];
  boName: any;
  payingPremium: any;
  nameOfPayor: any;
  occupationPayor: any;
  contactPayor: any;
  payorRelationship: any;
  nricppPayor: any;
  payorReasons: any;
  highRisk: any;
  complianceReview: any;
  complianceReviewDate: number;
  complianceRemarks: any;
  ceoReview: any;
  ceoReviewDate: number;
  ceoRemarks: any;
  highRiskReason: any;
  highRiskReasonOther: any;
  amlScreeningDoneBy: any;
  resolutionStatus: any;
  riskStatus: any;
  reason: any;
  notes: any;
  riskProfile: any;
  replacement: any;
  clientCallbackSelectedFc: any;
  premiumExceed: any;
  lastUpdatedDate: number;
}
